import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import { LocationProps } from '../../interfaces';
import { AllMarkdownRemarkQueryResult } from '../../interfaces/AllMarkdownRemark';
import { MarkdownFileNode } from '../../interfaces/MarkdownFileNode';
import { findKindergartenNodeByAllMarkdownRemark } from '../../utils/FindKindergartenNodeByAllMarkdownRemark';
import { theme } from '../../utils/Theme';
import GreenStripe from '../GreenStripe';

const SliderContainer = styled.div`
  width: 100%;
  height: 500px;

  ${theme.mediaQuerySizes.smallLaptop} {
    height: 400px;
  }

  ${theme.mediaQuerySizes.phone} {
    height: 300px;
  }
`;

const Image = styled(Img)`
  width: 100%;
  height: 500px;

  ${theme.mediaQuerySizes.smallLaptop} {
    height: 400px;
  }

  ${theme.mediaQuerySizes.phone} {
    height: 300px;
  }
`;

const SliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
};

interface CarouselProps {
  location: LocationProps;
}

const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/home-carousel/" } }) {
      nodes {
        fileAbsolutePath
        frontmatter {
          images {
            image {
              childImageSharp {
                fluid(maxWidth: 1400, maxHeight: 500, quality: 80) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const Carousel = (props: CarouselProps) => {
  return (
    <StaticQuery
      query={query}
      render={(data: AllMarkdownRemarkQueryResult<MarkdownFileNode>) => {
        return (
          <>
            <GreenStripe />
            <SliderContainer>
              <Slider {...SliderSettings}>
                {findKindergartenNodeByAllMarkdownRemark(
                  data.allMarkdownRemark.nodes,
                  props.location,
                )?.frontmatter?.images?.map((image, key) => {
                  return <Image key={key} fluid={image.image.childImageSharp.fluid} />;
                })}
              </Slider>
            </SliderContainer>
            <GreenStripe marginTop="0" />
          </>
        );
      }}
    />
  );
};
